import { Pane } from 'evergreen-ui';
import React, { memo } from 'react';
import facebookLogo from '../assets/facebook.png';
import linkedInLogo from '../assets/linkedin.png';
import { FooterLink } from './FooterLink';
import {linkPrefix} from './util';

const thisYear = new Date().getFullYear();

export const Footer = memo(() => (
    <Pane className="portal-layout-footer tracking-wider">
        <p className='portal-footer-copyright leading-relaxed'>
            © {thisYear} The Catalight Care Services
            <br />
            <FooterLink href={`https://providers${linkPrefix()}.catalight.org/terms-of-use/`}>
                Terms of Use
            </FooterLink>
            &nbsp; &nbsp;
            <FooterLink href={`https://providers${linkPrefix()}.catalight.org/privacy-policy/`}>
                Privacy Policy
            </FooterLink>
            &nbsp; &nbsp;
            <FooterLink href={`https://providers${linkPrefix()}.catalight.org/contact-us/`}>
                Contact Us
            </FooterLink>
        </p>
    </Pane>
));

export const Footer2 = memo(() => (
    <Pane className="portal-layout-footer">
        <Pane
            fontSize={27.5}
            textAlign='center'
            fontWeight={700}
            paddingY={30}
            className='tracking-wider'
        >
            Connect with us
        </Pane>

        <Pane className='portal-layout-footer-row' display="flex" justifyContent="center" paddingBottom={30}>
            <a rel="noopener noreferrer" href="https://www.facebook.com/theBHPN/" className="portal-footer-link" target="_blank"
               style={{ marginRight: '8px' }}
            >
                <img className="portal-layout-footer-logo" src={facebookLogo} alt="Facebook Logo" />
            </a>
            <a rel="noopener noreferrer" href="https://www.linkedin.com/company/18318422/" className="portal-footer-link" target="_blank">
                <img className="portal-layout-footer-logo" src={linkedInLogo} alt="LinkedIn Logo" />
            </a>
        </Pane>
        <Pane className='portal-layout-footer-row tracking-wider'>
            <Pane height={23} borderTopWidth={1} />
            <p className='portal-footer-copyright leading-relaxed'>
                © 2020 The Catalight Care Services
                <br />
                <FooterLink href={`https://providers${linkPrefix()}.catalight.org/terms-of-use/`}>
                    Terms of Use Agreement
                </FooterLink>
                &nbsp; &nbsp;
                <FooterLink href={`https://providers${linkPrefix()}.catalight.org/privacy-policy/`}>
                    Privacy Policy
                </FooterLink>
                &nbsp; &nbsp;
                <FooterLink href={`https://providers${linkPrefix()}.catalight.org/contact-us/`}>
                    Contact Us
                </FooterLink>
            </p>
        </Pane>
    </Pane>
));
